import { NextFunction, Request, Response } from "express";
import { catchAsync } from "../../utils/catchAsync";
import { premiumServices } from "./premium.service";
import { sendResponse } from "../../utils/sendResponse";
import httpStatus from "http-status";

const getPremiumContent = catchAsync(
  catchAsync(async (req: Request, res: Response, next: NextFunction) => {
    const queryParams = req.query;
    const result = await premiumServices.getPremiumContent(queryParams);

    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Premium content retrieved Successfully!",
      data: result.data,
      meta: result.meta,
    });
  }),
);

export const premiumController = {
  getPremiumContent,
};
